module.exports = __webpack_public_path__ + "media/images/product_owners/s_and_t_90-21dc755a7c286b2deddb1f906c985cff.png";